<p-iconField class="control-search" iconPosition="left">
  <p-inputIcon styleClass="pi pi-search" />
  <input
    #search
    type="text"
    name="search"
    pInputText
    [value]="value()"
    [placeholder]="placeholder()"
    (input)="onSearchChange(search.value)"
  />
</p-iconField>
